module.exports = __webpack_public_path__ + "img/dsci0060.cd6c5e28.jpg";